import { booleanAttribute, ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { ButtonModule } from '@pin-up-global/common';
import { NgTemplateOutlet } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { Profile } from '@core/profile';
import { AvatarComponent } from '@shared/avatar';
import { MenuItemComponent } from '@shared/menu-item';
import { MatIcon } from '@angular/material/icon';
import { AuthService } from '@core/auth';

@Component({
  selector: 'ca-profile-card',
  standalone: true,
  imports: [
    ButtonModule,
    NgTemplateOutlet,
    TranslateModule,
    CdkConnectedOverlay,
    AvatarComponent,
    MenuItemComponent,
    MatIcon,
  ],
  templateUrl: './profile-card.component.html',
  styleUrl: './profile-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [
    {
      directive: CdkOverlayOrigin,
    },
  ],
  host: {
    class: 'ca-profile-card',
    '[class.ca-profile-card_opened]': 'isOpen()',
    '[class.ca-profile-card_collapsed]': 'isCollapsed()',
    '(click)': 'toggle()',
  },
})
export class ProfileCardComponent {
  overlayOrigin = inject(CdkOverlayOrigin);
  #authService = inject(AuthService);

  user = input.required<Profile>();
  isCollapsed = input(false, { transform: booleanAttribute });
  isOpen = signal(false);

  avatarPlaceholder = computed(() => `${this.user().first_name[0]}${this.user().last_name[0]}`);

  get overlayOriginWidth(): number {
    return this.overlayOrigin.elementRef.nativeElement.offsetWidth;
  }

  toggle(): void {
    this.isOpen.update((prev) => !prev);
  }

  logout(): void {
    this.#authService.logout();
  }
}
